export function isIframe(): boolean {
    return window.self !== window.top;
}
